var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_6658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62622 1.3252V2.65765",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29102 1.3252V2.65765",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6236 5.32129C10.8003 5.32129 10.9697 5.39148 11.0947 5.51642C11.2196 5.64136 11.2898 5.81082 11.2898 5.98751V11.3173C11.2898 12.0241 11.009 12.7019 10.5093 13.2017C10.0095 13.7014 9.33167 13.9822 8.6249 13.9822H4.62755C3.92077 13.9822 3.24294 13.7014 2.74318 13.2017C2.24341 12.7019 1.96265 12.0241 1.96265 11.3173V5.98751C1.96265 5.81082 2.03284 5.64136 2.15778 5.51642C2.28272 5.39148 2.45218 5.32129 2.62887 5.32129H11.956C12.6628 5.32129 13.3406 5.60205 13.8404 6.10182C14.3402 6.60159 14.6209 7.27941 14.6209 7.98619C14.6209 8.69296 14.3402 9.37079 13.8404 9.87056C13.3406 10.3703 12.6628 10.6511 11.956 10.6511H11.2898",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96118 1.3252V2.65765",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_6658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTea);
export default __webpack_public_path__ + "static/media/tea.5cfd8b0fe686b57a7a74a204a5aa2148.svg";
export { ForwardRef as ReactComponent };